<template>
  <div class="container mt-4 mb-5" style="max-width: 1100px">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h3 class="m-0">Version und Changelog</h3>
      <router-link class="btn btn-outline-secondary btn-sm" :to="{ name: 'Invoices' }">Zurück</router-link>
    </div>

    <div v-if="loading" class="alert alert-secondary">Lade Release-Informationen...</div>
    <div v-else-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

    <template v-else>
      <div class="row g-3 mb-4">
        <div class="col-md-6">
          <div class="card h-100">
            <div class="card-body">
              <h5 class="card-title">Backend (deployte Version)</h5>
              <div class="small text-muted mb-2">Version</div>
              <div><code>{{ releaseInfo.version }}</code></div>
              <div class="small text-muted mt-3 mb-2">Commit</div>
              <div><code>{{ releaseInfo.commitSha }}</code></div>
              <div class="small text-muted mt-3 mb-2">Build-Zeit (UTC)</div>
              <div>{{ releaseInfo.buildDateUtc || "-" }}</div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="card h-100">
            <div class="card-body">
              <h5 class="card-title">Frontend (Build-Metadaten)</h5>
              <div class="small text-muted mb-2">Version</div>
              <div><code>{{ frontendVersion }}</code></div>
              <div class="small text-muted mt-3 mb-2">Commit</div>
              <div><code>{{ frontendCommit }}</code></div>
              <div class="small text-muted mt-3 mb-2">Build-Zeit (UTC)</div>
              <div>{{ frontendBuildDate }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Changelog</h5>
          <pre class="bg-light border rounded p-3 mb-0" style="white-space: pre-wrap">{{ releaseInfo.changelogMarkdown }}</pre>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import SystemService from "@/services/SystemService";

const loading = ref(true);
const errorMessage = ref("");
const releaseInfo = ref({
  version: "0.0.0-local",
  commitSha: "local",
  buildDateUtc: null,
  changelogMarkdown: "# Changelog\n\nKeine Daten verfügbar.",
});

const frontendVersion = process.env.VUE_APP_VERSION || "0.0.0-local";
const frontendCommit = process.env.VUE_APP_COMMIT_SHA || "local";
const frontendBuildDate = process.env.VUE_APP_BUILD_DATE_UTC || "1970-01-01T00:00:00Z";

onMounted(async () => {
  try {
    const response = await SystemService.getReleaseInfo();
    releaseInfo.value = response?.data || releaseInfo.value;
  } catch (error) {
    errorMessage.value = "Release-Informationen konnten nicht geladen werden.";
    console.error(error);
  } finally {
    loading.value = false;
  }
});
</script>
